export default __webpack_public_path__ + "static/madridJS@2x-10febc5a322a85b53884a20807468cdb.png";